var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._b({class:['badge', 'text-white', _vm.paymentMethods[_vm.paymentMethod].class]},'span',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.paymentMethods[_vm.paymentMethod].text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }